import api from "@/api";
import { find as Rfind, propEq as RpropEq } from "ramda";
import { WorkOrderNote } from "@/store/modules/workOrderNotes";
import { JSConn } from "@/utilities/js-conn";

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    work_order_instruction: {
      ...jsConn.formParams,
    },
  };
};

const itemDetails = {
  pluralName: "work_order_instructions",
  singularName: "work_order_instruction",
};

interface WorkOrderInstructionState {
  workOrderInstructions: WorkOrderNote[];
  workOrderInstruction: WorkOrderNote | {};
}

const state: WorkOrderInstructionState = {
  workOrderInstructions: [],
  workOrderInstruction: {},
};

const mutations = {
  LOAD_WORK_ORDER_INSTRUCTION(
    state: WorkOrderInstructionState,
    payload: WorkOrderNote,
  ) {
    state.workOrderInstruction = payload;
  },
  LOAD_WORK_ORDER_INSTRUCTIONS(
    state: WorkOrderInstructionState,
    payload: WorkOrderNote[],
  ) {
    state.workOrderInstructions = payload;
  },
};

const actions = {
  needWorkOrderInstructions(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
      context.commit("LOAD_WORK_ORDER_INSTRUCTIONS", jsConn.response);
      return Promise.resolve(jsConn);
    });
  },
  needWorkOrderInstruction(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api.getItem(jsConn, itemDetails).then((jsConn: JSConn) => {
      context.commit("LOAD_WORK_ORDER_INSTRUCTION", jsConn.response);
      return Promise.resolve(jsConn);
    });
  },
  deleteWorkOrderInstruction(_context: any, jsConn: JSConn) {
    // set the api params to be correct
    // this may be called from multiple places
    // as of 2019-03-22 it is just called from the
    // workorder show page and there the entire Instruction
    // is being set as the form params
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .deleteItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
  createWorkOrderInstruction(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .createItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        context.commit("LOAD_WORK_ORDER_INSTRUCTION", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
  updateWorkOrderInstruction(_context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;

    return api
      .updateItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
};

const getters = {
  workOrderInstruction: (state: WorkOrderInstructionState) =>
    state.workOrderInstruction,

  workOrderInstructions: (state: WorkOrderInstructionState) =>
    state.workOrderInstructions,

  workOrderInstructionById: (state: WorkOrderInstructionState) => (
    id: string,
  ) => {
    return Rfind(instruction => {
      return RpropEq("id", id, instruction);
    }, state.workOrderInstructions);
  },
};

const workOrderInstructionsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default workOrderInstructionsModule;
